export enum LaserGas {
  O2 = "O2",
  N2 = "N2",
}
